import 'remodal'
;(function ($) {
	$.fn.modalBlock = function (options) {
		// This is the easiest way to have default options.
		var settings = $.extend(
			{
				// These are the defaults.
				trigger: '.modal-trigger',
			},
			options
		)
		const modal_block = $(this).remodal({
			hashTracking: false,
		})

		$(settings.trigger).on('click', function (event) {
			event.preventDefault()

			modal_block.open()
		})
		return this
	}
})(jQuery)
